import React, {useEffect, useState} from 'react';
import FunctionSidebarContainer from "../common/FunctionSidebar/FunctionSidebarContainer";
import CardMedia from "@material-ui/core/CardMedia";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardContent from "@material-ui/core/CardContent";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import {CustomInputNumber, LocationDropdown} from "./styles";
import {Field, FieldArray, Form, Formik} from "formik";
import Button from "@material-ui/core/Button";
import Menu from "@material-ui/core/Menu";
import TextField from "@material-ui/core/TextField";
import {themeButtons} from "../../css/themeButtons";
import AutoSaveWithDebounce from "../common/Autosave/AutoSaveWithDebounce";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import Preloader from "../common/Preloader/Preloader";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {useHistory} from "react-router-dom";
import AlertSavePage from "../common/AlertSavePage/AlertSavePage";


const RenderAddress = ({address, mapTarget}) => {
    let [show, setModalShow] = useState(false);

    //открытие/закрытие модалок
    const toggleShow = () => {
        setModalShow(!show)
    };

    return (
        <>
            <div id="adress" className="pb-4">
                <Card className="card">
                    <CardActionArea>
                        <Box className="card-body">
                            <Box className="box-address">
                                <CardContent>
                                    <Typography variant="h6" component="h6">
                                        Адрес:
                                    </Typography>
                                    <Typography>
                                        {address}
                                    </Typography>
                                </CardContent>
                            </Box>
                            {mapTarget && mapTarget.lon && mapTarget.lat && <Box className="box-map">
                                <CardMedia
                                    component="img"
                                    height="150"
                                    image={`https://static-maps.yandex.ru/1.x/?size=365,150&z=15&l=map&pt=${mapTarget.lon},${mapTarget.lat},pm2rdm`}
                                />
                            </Box>}

                        </Box>
                        {/*<Typography className="btn w-100 text-center">
                            Для изменения адреса необходимо
                            отправить запрос
                        </Typography>*/}
                    </CardActionArea>

                </Card>

            </div>

            {/*    {show && <Modal toggleShow={toggleShow} show={show} title={"Заявка на изменение адреса:"}>
                <div className="row">
                    <div className="col-12">
                        sdaSDASD
                    </div>
                </div>

            </Modal>}*/}
        </>
    )
}

const RenderDictance = ({onSubmit, distance}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [initialDropdownMenuList, setInitialDropdownMenuList] = useState([])
    const [initialValue, setInitialValue] = useState([])

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };


    useEffect(() => {
        if (distance && distance.place) {

            let dropdownList = []
            Object.keys(distance.place).slice(4).map((placeId) => {

                if (!distance.value.find(item => item.place == placeId)) {
                    dropdownList.push(distance.place[placeId])
                }
                setInitialDropdownMenuList(dropdownList)
            })

            let localInitialValue = []
            for (let i = 1; i <= Object.keys(distance.place).length; i++) {

                if (i <= 4 && !distance.value.find((places) => places.place == i)) {
                    localInitialValue.push({
                        place: distance.place[i].value,
                        measure: distance.measure[1].value,
                        distance: "",
                        type: distance.type[1].value,
                    })
                }
                if (distance.value.find((places) => places.place == i)) {
                    localInitialValue.push(distance.value.find((places) => places.place == i))
                }
            }


            setInitialValue({distance: localInitialValue})
        }
    }, [distance])


    const handleClose = (placeId) => {
        if (placeId) {
            setInitialDropdownMenuList(initialDropdownMenuList.filter(item => item.value !== placeId))
        }
        setAnchorEl(null);
    };


    const buttons = themeButtons();


    if (initialValue.length === 0) {
        return <Preloader loading={true}/>
    }
    return (
        <div id="distance" className="distance section">
            <h5 className="card-title mb-4">
                Расстояния до мест:
            </h5>
            <Formik initialValues={{...initialValue}}
                    enableReinitialize
                    onSubmit={onSubmit}>
                {({handleSubmit, values}) => (
                    <Form onSubmit={handleSubmit}>

                        <FieldArray name="distance">
                            {({insert, remove, push}) => (
                                <>
                                    <div className="row g-4">
                                        {Object.keys(values.distance).map((item, index) => (
                                            <div key={index}
                                                 className="col-12 col-sm-6 col-lg-4 col-xxl-3 distance__item">
                                                <label
                                                    className="form-label">{distance.place[values.distance[item].place].label}:</label>
                                                <div className="input-group">
                                                    <FormControl className="distance__item-col">
                                                        <Field name={`distance.${item}.distance`}>
                                                            {({field}) => (
                                                                <CustomInputNumber {...field}
                                                                                   placeholder="---"
                                                                                   type="number"/>
                                                            )}
                                                        </Field>
                                                    </FormControl>
                                                    <Typography
                                                        className="distance__item-col input-group-text">минут</Typography>
                                                    <Field name={`distance.${index}.measure`}>
                                                        {({field}) => (
                                                            <CustomInputNumber className={"d-none"} {...field}/>
                                                        )}
                                                    </Field>
                                                    <FormControl className="distance__item-col">
                                                        <Field name={`distance.${index}.type`}>
                                                            {({field}) => (
                                                                <Select
                                                                    {...field}
                                                                    defaultValue={values.distance[index]?.type}
                                                                    className="input-group-select"
                                                                    input={<LocationDropdown/>}
                                                                >
                                                                    {distance && Object.keys(distance.type).map((item) => (
                                                                        <MenuItem key={distance.type[item].value}
                                                                                  className="justify-content-center"
                                                                                  value={distance.type[item].value}>

                                                                            <FontAwesomeIcon
                                                                                icon={distance.type[item].faIcon}/>

                                                                        </MenuItem>
                                                                    ))}

                                                                </Select>
                                                            )}
                                                        </Field>
                                                    </FormControl>
                                                </div>

                                            </div>
                                        ))}

                                    </div>
                                    {initialDropdownMenuList.length > 0 && <div className="distance__item">
                                        <Button className={`btn ${buttons.btnLight}`}
                                                onClick={handleClick}>
                                            <FontAwesomeIcon icon={["fas", "plus"]} className="me-1"/>
                                            Добавить
                                        </Button>

                                        <Menu
                                            anchorEl={anchorEl}
                                            keepMounted
                                            className="dropdown-menu"
                                            open={Boolean(anchorEl)}
                                            onClose={handleClose}
                                        >
                                            {initialDropdownMenuList.map((place, index) => {
                                                return (
                                                    <MenuItem key={place.value + index}
                                                              className="dropdown-item"
                                                              onClick={() => {
                                                                  push({
                                                                      place: place.value,
                                                                      measure: "1",
                                                                      distance: "",
                                                                      type: "1"
                                                                  })
                                                                  handleClose(place.value)
                                                              }

                                                              }>
                                                        {place.label}
                                                    </MenuItem>
                                                )
                                            })}


                                        </Menu>
                                    </div>}

                                </>
                            )}
                        </FieldArray>


                        <AutoSaveWithDebounce debounceMs={10}/>
                    </Form>
                )}
            </Formik>
        </div>
    )
}

const RenderHowToGet = ({howToGet, onSubmit}) => {

    //валидация формы
    const validation = (value) => {
        const error = {}

        if (value.howToGet.length >= 2000) {
            error.howToGet = "Поле не может содержать более 2000 символов"
        }
        return error
    }

    return (
        <div id="howToGet" className="section">
            <h5 className="card-title mb-3">
                Как добраться:
            </h5>

            <Formik
                initialValues={{howToGet: howToGet ? howToGet : ''}}
                validate={validation}
                enableReinitialize
                onSubmit={onSubmit}>
                {({handleSubmit}) => (
                    <Form>
                        <div className="d-flex">
                            <Field name="howToGet">
                                {({field, form}) => (
                                    <TextField
                                        name={field.name}
                                        onChange={field.onChange}
                                        value={field.value}
                                        label="Описание проезда до объекта"
                                        multiline
                                        fullWidth
                                        rows={4}
                                        variant="outlined"
                                        inputProps={{maxLength: 2000}}
                                        helperText={`${field.value.length ? field.value.length : 0}/2000`}
                                    />
                                )}
                            </Field>
                        </div>
                        <AutoSaveWithDebounce debounceMs={10}/>
                    </Form>

                )}
            </Formik>

        </div>
    )
}


const ObjectLocation = (props) => {
    const [preSavedPage, setPreSavedPage] = useState({})
    const [unsavedPage, toggleUnsavedPage] = useState(false)
    const [targetRedirectLink, setTargetRedirectLink] = useState(false)
    const history = useHistory()

    const {objectId, address, distance, howToGet, savePage, mapTarget} = props

    const preSavePage = (value) => {
        setPreSavedPage({...preSavedPage, ...value})
        toggleUnsavedPage(true)
    }

    const savePageHandler = async () => {

        toggleUnsavedPage(false)

        let response = await savePage({object: objectId, section: "location", data: preSavedPage})

        if (response) {

            if (targetRedirectLink) {
                history.push(targetRedirectLink)
            }
        }

    }

    return (
        <div className="main edit-object">

            <div className="container-fluid">
                <RenderAddress address={address} mapTarget={mapTarget}/>
                <RenderDictance onSubmit={preSavePage} distance={distance}/>


                {/*Если объект абонентский то выводить инфо на странице, если коммиссия то отправлять при потдверждении брони письмом клиенту-*/}
                <RenderHowToGet onSubmit={preSavePage} howToGet={howToGet}/>
            </div>

            {unsavedPage && <StickyBottomButton action={savePageHandler}/>}
            <AlertSavePage unsavedPage={unsavedPage} btnOkAction={savePageHandler}
                           setTargetRedirectLink={setTargetRedirectLink} targetRedirectLink={targetRedirectLink}/>
            <FunctionSidebarContainer/>
        </div>
    )
}


export default ObjectLocation;